import { RootState } from '..';

export const serviceOrderSelector = (state: RootState) => state.serviceOrder;

export const serviceOrdersListSelector = (state: RootState) => state.serviceOrder.list;

export const serviceOrdersPaginationSelector = (state: RootState) => state.serviceOrder.pagination;

export const serviceOrdersOptionsSelector = (state: RootState) => state.serviceOrder.options;
